/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Rendering engine targeted by a graph.
 */
export var GraphType;
(function (GraphType) {
    GraphType["ECHARTS"] = "ECHARTS";
    GraphType["CHARTJS"] = "CHARTJS";
})(GraphType || (GraphType = {}));
